function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#264DE4",
  points: "5.66621022 12.959575 1.04871864 11.6777282 0.0197312715 0.136430551 11.3265291 0.136430551 10.2964507 11.6759203"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#2965F1",
  points: "9.41459071 10.9411252 10.294861 1.08010277 5.67313019 1.08010277 5.67313019 11.9784041"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EBEBEB",
  points: "2.37866244 5.36060419 2.5055286 6.77608133 5.67313019 6.77608133 5.67313019 5.36060419"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EBEBEB",
  points: "2.12374564 2.49561108 2.25241971 3.91111942 5.67313019 3.91111942 5.67313019 2.49561108"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EBEBEB",
  points: "5.67313019 9.03679255 5.66692716 9.03844463 4.09048273 8.61277283 3.98970673 7.48385108 2.56877465 7.48385108 2.76708484 9.70637775 5.66661545 10.5113077 5.67313019 10.5094997"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "8.95852716 5.36060419 9.21406741 2.49561108 5.66823632 2.49561108 5.66823632 3.91111942 7.66280917 3.91111942 7.53401042 5.36060419 5.66823632 5.36060419 5.66823632 6.77608133 7.41125881 6.77608133 7.24695628 8.61186885 5.66823632 9.03797704 5.66823632 10.5106219 8.57007362 9.70637775 8.59136341 9.46723351 8.92398963 5.74070391"
});

var SvgCss3 = function SvgCss3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-label": "CSS3",
    viewBox: "0 0 12 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCss3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/css3.fd168b1b.svg";
export { ForwardRef as ReactComponent };